import Character from "../character/Character";
import Vector from "../math/Vector";
import SpriteAnimation from "../sprite/SpriteAnimation";
import SpriteEffect from "./SpriteEffect";

export default class BasicSpriteEffect extends SpriteEffect {
    constructor() {
        super();

        /**
         * @constant
         * @type {Vector}
         */
        this.effectPosition = new Vector(0, 0);
    }

    /**
     * @param {Character} effectOwner
     * @param {SpriteAnimation} spriteAnimation
     * @param {Vector} effectPosition 
     */
    set(effectOwner, spriteAnimation, effectPosition) {
        super.set(effectOwner, spriteAnimation);

        this.effectPosition.copy(effectPosition);
    }

    /**
     * @override
     * @param {number} frameTimeRatio 
     */
    updateEffectForFrameInternal(frameTimeRatio) {
        // Basic sprite effects are finished when the sprite animation ends.
        const animationLoopCompleted = this.spriteAnimation.isAnimationLoopCompleted(this.getStartTime()); 
        if (animationLoopCompleted && !this.isFinishedAndAvailable()) {
            this.markEffectAsFinishedButInUse();
        }
    }

    /**
     * @override
     * @returns {Vector}
     */
    getPosition() {
        return this.effectPosition;
    }

}